
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ats/track-and-collaborate",
      function () {
        return require("private-next-pages/ats/track-and-collaborate/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ats/track-and-collaborate"])
      });
    }
  